const modals = document.querySelectorAll('[data-block="modal"]');

if (modals) {
    modals.forEach(modal => {
        modal.addEventListener("click", ({ target }) => {
            const close = target.closest('[data-close="modal"]');

            if (close) {
                closeModal(modal);
            }
        });
    });
}

export function setModalContent(el, data) {
    if (el) {
        const title = el.querySelector('[data-modal="title"]');

        if (title) {
            title.innerHTML = data.title;
        }
    }
}

export function openModal(el) {
    if (el) {
        el.classList.add("open");
        document.body.classList.add("open");
    }
}

export function closeModal(el) {
    el.classList.remove("open");
    document.body.classList.remove("open");
}
